import type { AppConfigMasteryLevelsType } from "@memorang/constants/config/schema";
import type { Distribution, ScoreRange } from "../../types";
import type { AppTheme } from "../../useAppTheme";

type ProgessData = {
	x: string;
	y: number;
};

const getMasteryProgessData = (dist: Distribution): ProgessData[] => {
	const { high, low, medium, none } = dist;
	const sortedDist = {
		high,
		medium,
		low,
		none,
	};
	const tArray = Object.keys(sortedDist).map((item) => ({
		x: item,
		y: dist[item as keyof Distribution],
	}));

	return tArray;
};
const getProgressRingData = (
	distribution: Distribution | number[],
	selected?: boolean,
) => {
	if (!Array.isArray(distribution)) {
		return getMasteryProgessData(distribution);
	}
	if (selected) {
		return [{ x: "select", y: 1 }];
	}
	return [
		{ x: "select", y: distribution[0] },
		{ x: "select", y: distribution[1] },
	];
};

export const getProgressColorScale = (
	score: number,
	theme: AppTheme,
	scoreRanges?: ScoreRange[],
	masteryLevels?: AppConfigMasteryLevelsType,
) => {
	const { high, low, none: empty, medium } = theme.palette.progress;

	if (!scoreRanges && masteryLevels?.length) {
		const level = masteryLevels.find(
			(l) => score >= l.range.score[0] && score <= l.range.score[1],
		);
		const color = level
			? theme.dark
				? level.darkColor
				: level.lightColor
			: empty;
		return [color, empty];
	}

	const lowScoreRange = scoreRanges ? scoreRanges[0].rangeArray[1] : 75;
	const mediumScoreRange = scoreRanges ? scoreRanges[1].rangeArray[1] : 85;
	if (score < lowScoreRange) {
		return [low, empty];
	}
	if (score < mediumScoreRange) {
		return [medium, empty];
	}
	return [high, empty];
};

const getColorScale = (
	theme: AppTheme,
	selected?: boolean,
	variant?: "progress" | "mastery",
	score?: number,
	masteryLevels?: AppConfigMasteryLevelsType,
) => {
	const {
		colors: { secondary },
		palette: { progress },
	} = theme;
	const { high, low, none: empty, medium } = progress;
	if (selected) {
		return [secondary];
	}
	if (variant === "progress") {
		return getProgressColorScale(score || 0, theme, undefined, masteryLevels);
	}
	if (masteryLevels?.length) {
		return [
			...[...masteryLevels]
				.sort((a, b) => a.sortOrder - b.sortOrder)
				.map((l) => (theme.dark ? l.darkColor : l.lightColor)),
			empty,
		];
	}
	return [high, medium, low, empty];
};
export { getProgressRingData, getColorScale };
